import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'mapGet'
})
export class MapGetPipe<K, V> implements PipeTransform {
  transform(map$: Observable<Map<K, V>>, key: K): Observable<V | undefined> {
    return map$.pipe(map(m => m?.get(key)));
  }
}
